import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter013() {
  return <KbChapterPage slug="chapter-013" />;
}

(Chapter013 as unknown as { path: string }).path = "/theory-album/013";
